import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { JOURNAL } from "../lib/data";

export default function Journal() {
  return (
    <section id="journal" className="relative py-24 md:py-32 border-t border-white/10">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 items-end mb-12 md:mb-16">
          <div className="col-span-12 md:col-span-7">
            <span className="em-tag">06 — Journal</span>
            <h2
              className="mt-6 font-display font-extrabold tracking-tighter leading-[0.98]"
              style={{ fontSize: "clamp(1.8rem, 3.6vw, 3.4rem)" }}
            >
              Notes from the control room.
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 md:col-start-9 text-white/70 leading-relaxed">
            Field notes, playbooks and case studies — written between shows, by the team producing them.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-5 md:gap-6">
          {JOURNAL.map((j, i) => (
            <motion.a
              key={j.title}
              href="#"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
              className="em-card p-6 md:p-7 col-span-12 md:col-span-4 group flex flex-col justify-between min-h-[240px]"
              data-testid={`journal-item-${i}`}
            >
              <div className="flex items-center justify-between">
                <span className="em-tag">{j.tag}</span>
                <span className="font-mono-em text-[0.68rem] tracking-[0.22em] text-white/45">
                  {j.date}
                </span>
              </div>
              <div>
                <h3 className="font-display font-bold text-xl md:text-[1.4rem] leading-[1.15] tracking-tight">
                  {j.title}
                </h3>
                <div className="mt-5 flex items-center justify-between text-white/60 text-xs">
                  <span className="font-mono-em tracking-[0.24em] uppercase">
                    {j.read}
                  </span>
                  <ArrowUpRight
                    size={16}
                    className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
                  />
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
